import React, { useState, useEffect } from "react";
import Menu from "../Menu";
import { useAlert } from "react-alert";
import { http } from "../../services/http";
import { PagingState, CustomPaging, FilteringState, IntegratedFiltering, SelectionState, IntegratedSelection, IntegratedPaging, EditingState } from "@devexpress/dx-react-grid";
import { Grid, Table, TableHeaderRow, PagingPanel, TableFilterRow, TableEditRow, TableEditColumn } from "@devexpress/dx-react-grid-material-ui";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import { QueryString, Update, APPNAME_APADIGITAL } from "../utils/react_grid_utils";
import { editColumnMessages } from "../utils/react_grid_edit_command_localization";
import { BooleanCheckboxTypeProvider } from "../utils/react_grid_boolean_checkbox_column";
import { SelectTypeProvider } from "../utils/react_grid_select_column";
import authenticatedUserContext from "../security/AuthenticatedUserContext";
import { ExportXlsx } from "../utils/react_grid_utils";
import CookieService from "../../services/CookieService";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Header from "../Header";


const api_resource = "/history";
let getRowId = (row) => row.form_id;

export default function HistoryTable() {

   const alert = useAlert();
   const [pageIndex, setPageIndex] = useState(0);
   const [pageSize] = useState(20);
   const [totalItens, setTotalItens] = useState(0);
   //const [filters, setFilters] = useState([]);
   const [rows, setRows] = useState([]);
   const [filtersApi, setFiltersApi] = useState([]);
   const [filteringStateColumnExtensions] = useState([
      { columnName: "created_at", filteringEnabled: false },
      { columnName: "inicio_vigente", filteringEnabled: false },
      { columnName: "fim_vigente", filteringEnabled: false }
    ]);
   const [tableColumnExtensions] = useState([
      { columnName: "created_at", editingEnabled: false  ,width: "10%"},
      { columnName: "type", editingEnabled: false  ,width: "20%"},
      //{ columnName: "id", editingEnabled: false  ,width: 150},
      { columnName: "module_name", editingEnabled: false ,width: "30%" },
      { columnName: "changer_name", editingEnabled: false  ,width: "30%"},
      
     
   ]);

   var columns = [
      { name: "created_at", title: "Data" },
      { name: "type", title: "Tipo" },
      //{ name: "id", title: "ID"},
      { name: "module_name", title: "Módulo"},
      { name: "changer_name", title: "Usuário" },
     
   ];

   //Modal
   const [selectedRow, setSelectedRow] = useState(null); 
   const [open, setOpen] = useState(false); 

   const handleClickOpen = (row) => {
      setSelectedRow(row);
      setOpen(true);
   };

   const handleClose = () => {
      setOpen(false);
   };

   //
   const filterCell = props => {
      return <TableFilterRow.Cell {...props} />;
    };

   var start = new Date();
   start.setDate(start.getDate() - 30); // Subtrai 30 dias

   const [dtStart, setDtStart] = useState(start.toISOString().slice(0, 10));
   const [dtEnd, setDtEnd] = useState(new Date().toISOString().slice(0, 10));

   const [filtroStatus, setFiltroStatus] = useState('all');
   const [filtroContato, setFiltroContato] = useState('all');

   function get(page, filters) {
      let queryString = QueryString(page, pageSize, filters);
      //queryString = queryString + `&contato=${filtroContato}&status=${filtroStatus}`;

      if (dtStart && dtStart !== '') {
         queryString = queryString + "&dataStart=" + dtStart;
      }
      if (dtEnd && dtEnd !== '') {
         queryString = queryString + "&dataEnd=" + dtEnd;
      }

      http.get(api_resource + queryString).then(
         (response) => {
            const data = response?.data?.data || [];
      
            // Aplica a transformação no campo `changer_name`
            const transformedData = data.map((row) => ({
              ...row, // Mantém os outros campos
              module_name: capitalizeFirstLetter(row.module_name),
              changer_name: capitalizeFirstLetter(row.changer_name) + ` (${row.changer_email})`,
              created_at: formatDateTime(row.created_at)
            }));
            setTotalItens(parseInt(response?.data?.total, 10));
            setRows(transformedData); // Define os dados transformados no estado
         },
         (error) => {
            setRows([]);
            setTotalItens(0);
            console.log(error);
         }
      );   
   }

   function onFormSubmit(e) {
      e.preventDefault(); //Previne default de submit form e não atualiza a pagina toda
      setTotalItens(0)
      setPageIndex(0)
      get(0, []);
   }

   useEffect(() => {
      get(0, []);
   }, []);
   
   function handlePage(page, totalRows) {
      setPageIndex(page);
      get(page, filtersApi);
    }

    function getDifferences(oldData, newData) {
      try {
         if (!oldData || !newData)
            return {}
         const differences = {};
       
         Object.keys(oldData).forEach((key) => {
           if (oldData[key] !== newData[key]) {
             differences[key] = {
               old: oldData[key],
               new: newData[key],
             };
           }
         });
       
         return differences;
      } catch (error) {
         console.log('getDifferences error', error)
         return {}
      }
      
    }

   const capitalizeFirstLetter = (str) => {
      if(!str)
         return
      return str
         .toLowerCase()
         .replace(/_/g, ' ') // Substitui "_" por espaço
         .replace('.', '-> ') // Substitui "." por espaço
         .split(' ')          // Divide a string em palavras
         .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitaliza cada palavra
         .join(' ');          // Junta as palavras de volta com espaços
    };

   const formatDateTime = (dateTime) => {
      const date = new Date(dateTime);
      const formattedDate = date.toLocaleDateString("pt-BR"); // Formato DD/MM/YYYY
      const formattedTime = date.toLocaleTimeString("pt-BR", { hour: '2-digit', minute: '2-digit' }); // Formato HH:MM
      return `${formattedDate} ${formattedTime}`;
   };

   const TableRowComponent = ({ row, ...restProps }) => (
      <TableRow
         {...restProps}
         style={{ cursor: "pointer" }} // Cursor to indicate clickable row
         onClick={() => handleClickOpen(row)} // Event handler to open modal
      />
   );

   return (
      <div id="wrapper">
         <Menu />
         <div id="page-wrapper" className="gray-bg">
            <Header/>
            <div className="row wrapper border-bottom white-bg page-heading">
               <div className="col-lg-10">
                  <h2><i className="fa fa-history"></i> Histórico</h2>
               </div>
               <div className="col-lg-2" style={{ paddingTop: "15px", display: 'flex', justifyContent: 'flex-end'}}>

               </div>
            </div>
            <div className="wrapper wrapper-content animated fadeInRight">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="ibox ">
                        <div className="ibox-content">
                           <form style={{ marginLeft: 10 }}>
                              <div className="row" >
                              <div className="col-md-6">
                                    <label className="col-sm-12 col-form-label" style={{ paddingLeft: "1px" }}>
                                       Data
                                    </label>
                                    <div className="d-flex" style={{ gap: "10px" }}>
                                       <input
                                          type="date"
                                          value={dtStart}
                                          onChange={(e) => setDtStart(e.target.value)}
                                          className="form-control col-sm-6"
                                          style={{ ma: "50%" }} // Espaço entre os inputs
                                       />
                                       <input
                                          type="date"
                                          value={dtEnd}
                                          onChange={(e) => setDtEnd(e.target.value)}
                                          className="form-control col-sm-6"
                                       />
                                    </div>
                              </div>
                              {/* <div className="col-md-2">
                                 <label className="col-sm-12 col-form-label" >
                                    Módulo
                                 </label>
                                 <div className="row" >
                                    <div className="col-sm-12" >
                                    <select 
                                       value={filtroStatus} 
                                       className="form-control col-sm-12"
                                       style={{height: 35.6}} //É o tamanho do input date, select por algum motivo não acompnha o tamanho
                                       onChange={(e) => setFiltroStatus(e.target.value)}
                                    >
                                       <option value="all">Todos</option>
                                       <option value="liberado">Liberado</option>
                                       <option value="nao_liberado">Não Liberado</option>
                                    </select>
                                    </div>
                                 </div>                               
                              </div> */}
                              <div className="col-md-2">
                                 <div className="col-sm-12" style={{ paddingTop: "35px" }}>
                                    <button className="btn btn-success col-sm-12" type="submit" onClick={onFormSubmit}>
                                       Buscar
                                    </button>
                                 </div>
                              </div>
                           </div>
                        </form>
                     </div>

                        <div className="ibox-content">
                           <Grid rows={rows} columns={columns} onRowClick={(row) => handleClickOpen(row)} >
                              <PagingState currentPage={pageIndex} pageSize={pageSize} onCurrentPageChange={handlePage} />
                              <FilteringState/>
                              <IntegratedFiltering />
                              <Table columnExtensions={tableColumnExtensions}  rowComponent={TableRowComponent}/>
                              <TableHeaderRow />                             
                              
                              <CustomPaging totalCount={totalItens} />
                              <PagingPanel />
                              <TableFilterRow 
                                 cellComponent={filterCell}
                                 showFilterSelector={false}
                              />
                           </Grid>

                           <Dialog 
                              open={open} 
                              onClose={handleClose} 
                              maxWidth="md"
                              fullWidth
                              PaperProps={{
                                 style: {
                                    width: '600px', 
                                    margin: '0 auto'
                                 },
                              }}
                              >
                              
                           <DialogTitle style={{ position: 'relative', color: "#3f51b5", textAlign: 'center' }}>
                              <span style={{ display: 'inline-block', width: '100%' }}>{`${capitalizeFirstLetter(selectedRow?.module_name || '')} (${selectedRow?.id})`}</span>
                              <IconButton
                                 edge="end"
                                 color="inherit"
                                 onClick={handleClose}
                                 aria-label="close"
                                 style={{
                                    position: 'absolute',
                                    right: 30,
                                    top: 20,
                                    padding: 0
                                 }}
                              >
                                 <CloseIcon />
                              </IconButton>
                           </DialogTitle>
                              
                           <DialogContent >
                              <DialogContentText style={{ color: "black" }}>
                                 {selectedRow && (
                                 <> 
                                    <span>
                                       <b>ID:</b> {selectedRow?.id}
                                       <br />
                                       <b>Data:</b> {selectedRow?.created_at}
                                       <br />
                                       <b>Usuário:</b> {selectedRow?.changer_name}
                                    </span>
                                    <hr />
                                    <h2 style={{ color: '#3f51b5' }}>Alterações</h2>
                                       <span>
                                       {(selectedRow?.old_data && selectedRow?.new_data) ? (
                                          <ul>
                                             {Object.entries(getDifferences(selectedRow?.old_data, selectedRow?.new_data)).map(([key, diff]) => (
                                             <li key={key}>
                                                <strong>{key}:</strong> 
                                                <br/>
                                                <strong style={{ color: '#3f51b5' }}>Old:</strong> {key === 'updated_at' ? formatDateTime(diff.old) : JSON.stringify(diff.old)}<br/>
                                                <strong style={{ color: '#3f51b5' }}>New:</strong> {key === 'updated_at' ? formatDateTime(diff.new) : JSON.stringify(diff.new)}
                                             </li>
                                             ))}
                                          </ul>
                                       ) : (
                                          ''
                                       )}
                                       </span>
                                       <hr />
                                       <h2 style={{ color: '#3f51b5' }}>Old Data</h2>
                                       <span>{JSON.stringify(selectedRow?.old_data, null, 2)}</span>
                                       <hr />
                                       <h2 style={{ color: '#3f51b5' }}>New Data</h2>
                                       <span>{JSON.stringify(selectedRow?.new_data, null, 2)}</span>

                                 </>
                                 )}
                              </DialogContentText>
                           </DialogContent>
                           <DialogActions>
                              <Button onClick={handleClose} color="primary">
                                 Fechar
                              </Button>
                           </DialogActions>
                           </Dialog>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}
